import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'ps-design';
import './SupportSubmitFailure.scss';

const propTypes = {
  missingFields: PropTypes.bool,
  doClose: PropTypes.func.isRequired
};

const SupportSubmitFailure = props => {
  let headerText, guidanceText;

  if (props.missingFields) {
    headerText = 'Failed to submit the request.';
    guidanceText = 'Please fill out all of the required fields below and try again.';
  } else {
    headerText = 'Failed to submit the request. Please try again.';
    guidanceText = 'You can also contact help-marketpay@payscale.com or your client manager.';
  }

  return (
    <div className="support-submit-failure">
      <Alert
        message={
          <div>
            <h4>{headerText}</h4>
            <div className="support-submit-failure__notification-text">{guidanceText}</div>
          </div>
        }
        onClickClose={props.doClose}
        close={true}
      />
    </div>
  );
};

SupportSubmitFailure.propTypes = propTypes;
export default SupportSubmitFailure;
